import React from "react";
import { useHistory } from "react-router-dom";
import Container from "@mui/material/Container";
import { Grid, Paper } from "@mui/material";
import useSession from "../../effects/useSession";
import pageStyles from "../pageStyles";
import Layout from "../Layout";
import { ErrorRounded } from "@mui/icons-material";
export default function Error() {
  const session = useSession();
  const history = useHistory();
  const classes = pageStyles();

  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper className={classes.paper}>
                <div id="error-message" className={classes.errorDiv}>
                  <ErrorRounded className={classes.roundedError} />
                  <h1>Something went wrong</h1>
                  <p>
                    There is a problem processing your request. Please try again
                    later or contact our support team if the problem persists.
                  </p>
                  <p>We&#39;re sorry for the inconvenience. </p>
                  <button
                    onClick={() => history.go(-1)}
                    className={classes.returnToLastPageButton}
                  >
                    Return to last page
                  </button>
                </div>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
}
